// extracted by mini-css-extract-plugin
export default {"mainPage__wrapper":"MainPage_mainPage__wrapper__42dIE"};